module.exports = __webpack_public_path__ + "static/media/lasers.6f3d5fd6.svg";